import * as React from 'react';
import StopgapSortLinkDoNotUse from './StopgapSortLinkDoNotUse';

interface TableHeader {
  element: JSX.Element | string;
  className?: string;
}

interface TableData {
  rows: any[][];
  headers: TableHeader[];
}

enum SortDirection {
  Ascending = 'ascending',
  Descending = 'descending',
  None = 'none'
}

interface SortConfig {
  //Initial sort direction
  sortDirection: SortDirection;
  //Initial sort column index referring to the sortable header's ordinal
  sortColumnIndex: number;
  //This is a number array containing the index of sortable column in the table
  sortableHeaders: number[];
}

interface TableProps {
  tableClass: string;
  tableData: TableData;
  sortConfig: SortConfig;
  onSort: (colIndex: number, sortDir: SortDirection) => void;
}

function Table(props: TableProps) {
  const handleSortClick = (colIndex: number, sortDir: SortDirection) => {
    props.onSort(colIndex, sortDir);
  };

  const renderData = props.tableData.rows.map((row, rowIndex) => {
    return (
      <tr data-testid={`table-data-row-${rowIndex}`} key={rowIndex}>
        {row.map((column, colIndex) => {
          return (
            <td data-testid={`table-cell-r${rowIndex}-c${colIndex}`} key={colIndex}>
              {column}
            </td>
          );
        })}
      </tr>
    );
  });

  return (
    <div className="table-component">
      {props.tableData.rows && props.tableData.rows.length > 0 && (
        <table className={props.tableClass ? `table ${props.tableClass}` : 'table'} data-testid="table-main">
          <thead data-testid="table-head">
            <tr data-testid="table-header-row">
              {props.tableData.headers.map((header, index) => {
                return (
                  <th key={index} className={header.className}>
                    <StopgapSortLinkDoNotUse
                      testIdKey={index}
                      element={header.element}
                      sortable={props.sortConfig.sortableHeaders.includes(index)}
                      sortDirection={props.sortConfig.sortDirection}
                      onSort={handleSortClick}
                    />
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody data-testid="table-body">{renderData}</tbody>
        </table>
      )}
    </div>
  );
}

export default Table;
